<template>
    <th
        class="whitespace-nowrap bg-white px-2 py-3 first:sticky first:left-0 first:pl-5 last:sticky last:right-0 last:pr-5"
    >
        <TableHeaderItem>
            {{ $t('actions') }}
        </TableHeaderItem>
    </th>
</template>
<script setup lang="ts">
import { TableHeaderItem } from '@src/components'
</script>
